export default function SelectInfo({ description }) {
  return (
    <div>
        <div className="absolute right-12 top-1/2 transform -translate-y-1/2 group">
        <div className="w-4 h-4 bg-gray-400 hover:bg-gray-600 rounded-full flex items-center justify-center cursor-help transition-colors">
            <span className="text-white text-xs font-bold">?</span>
        </div>
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
            {description}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
        </div>
        </div>
    </div>
  );
}